import * as urls from 'lib/urls'
import { TextLink } from 'baby-design'
import { CONFIG } from 'shared/constants'
import css from './banner.scss'
import useFeatureFlag from 'shared/hooks/useFeatureFlag/useFeatureFlag'

interface RegistryDiscountBannerProps {
  openModal: () => void
}
const RegistryDiscountBanner = ({ openModal }: RegistryDiscountBannerProps) => {
  const { flagValue: isRegistryDiscountRevampEnabled } = useFeatureFlag(
    '24e_ff_shop_reg_discount_revamp',
    false
  )

  const onClick = () => {
    if (isRegistryDiscountRevampEnabled) {
      return () => {
        openModal()
      }
    } else {
      return () => {
        window.location.href = urls.registryShopPath
      }
    }
  }

  return (
    <div className={css.shopRegistryDiscountBanner}>
      <div className="container">
        <div className={css.flexRow}>
          <div className={css.middle}>
            <span>
              Get {CONFIG.store.registryDiscountPctDisplay} off at Babylist Shop
            </span>{' '}
            <TextLink
              underline
              size="sm"
              variant="eggplant"
              weight="regular"
              onClick={onClick()}
            >
              Learn more
            </TextLink>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RegistryDiscountBanner
